import { createContext } from 'react';

const ChartContext = createContext({
  currentChartGroupConfigurations: {},
  currentControlStrategyConfigurations: {},
  filteredShortKeyData: [],
  filteredChartHits: [],
  currentLocation: null,
  currentType: null,
  currentProduct: null,
  currentMethod: null,
  currentParameter: null,
  currentShortKey: null,
  currentFullKey: null,
  currentSummary: null,
  resultsDataTableData: [],
  chartData: [],
  permissionData: {},
  personnel: [],
  currentPersonnel: [],
  summaries: []
});

export default ChartContext;
